enum LogicalOperator {
    And = 1,
    Or = 2,
    NotEnd = 3,
    NotOr = 4,
}

export default LogicalOperator;
